module.exports = __webpack_public_path__ + "img/solution-chassisHIL-intro.9efd9b2a.png";